import { Injectable, signal } from '@angular/core';
import { desktopDto } from '@vectronic/desktop-api';
import { SelectedId } from '@vectronic/util';

@Injectable({ providedIn: 'root' })
export class UtilService {
  activeFiltersCount = signal<number>(0);

  hasNewerFirmware(connection?: desktopDto.DeviceConnection) {
    if (!connection?.newestFirmwareVersion) return false;
    if (connection.isBootloader) return true;
    const { major, minor, release } = connection.firmwareVersion.version;
    const { version } = connection.newestFirmwareVersion;
    if (version.major < major) return false;
    if (version.major > major) return true;
    if (version.minor < minor) return false;
    if (version.minor > minor) return true;
    if (version.release > release) return true;
    return false;
  }

  setSessionDeviceIds = (selectedCollarIds: SelectedId[]) => {
    const serializedIds = JSON.stringify(selectedCollarIds);
    sessionStorage.setItem('DeviceIds', serializedIds);
  };

  getSessionDeviceIds = (): SelectedId[] => {
    const collarIds = sessionStorage.getItem('DeviceIds');
    if (!collarIds || collarIds === 'undefined') return [];
    return JSON.parse(collarIds);
  };

  clearDeviceListFilters() {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith('device-list-filters-'))
      .forEach((key) => sessionStorage.removeItem(key));
  }

  clearLocalDeviceState() {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith('local-device-'))
      .forEach((key) => sessionStorage.removeItem(key));
  }

  clearDeviceSelectorSession() {
    console.log('Device selection changed, clearing local device state3.');
    this.clearLocalDeviceState();
    this.setSessionDeviceIds([]);
  }
}
